import {
	FETCH_APPS_STATS_BEGIN,
	FETCH_APPS_STATS_ERROR,
	FETCH_APPS_STATS_SUCCESS,
	FETCH_COMPANIES_STATS_BEGIN,
	FETCH_COMPANIES_STATS_ERROR,
	FETCH_COMPANIES_STATS_SUCCESS,
	FETCH_COMPANY_STATS_BEGIN,
	FETCH_COMPANY_STATS_ERROR,
	FETCH_COMPANY_STATS_SUCCESS,
	FETCH_FILTERED_COMPANIES_STATS,
	FETCH_FILTERED_COMPANY_STATS,
	FETCH_FILTERED_STORE_STATS,
	FETCH_STORE_STATS_BEGIN,
	FETCH_STORE_STATS_ERROR,
	FETCH_STORE_STATS_SUCCESS,
	FETCH_TOTAL_STATS_BEGIN,
	FETCH_TOTAL_STATS_ERROR,
	FETCH_TOTAL_STATS_SUCCESS,
} from '../actions/statsActions';

const defaultStatsState =  {
	stats: [],
	loading: false,
	// pagination: {},
};

const defaultCompanyStatsState =  {
	companyStats: [],
    storesStats: [],
	loading: false,
	// pagination: {},
};

const defaultStoreStatsState =  {
	storeStats: [],
    uploadReports: [],
	loading: false,
	pagination: {
		numberOfElements : 0,
		totalElements: 0,
		totalPages: 0
	},
};

const defaultAppsStatsState =  {
	appsStats: [],
	loading: false,
	pagination: {
		numberOfElements : 0,
		totalElements: 0,
		totalPages: 0
	},
};

const defaultTotalStatsState =  {
	totalStats: [],
	loading: false,
	pagination: {
		numberOfElements : 0,
		totalElements: 0,
		totalPages: 0
	},
};


export const companiesStatsReducer  = (state = defaultStatsState, action) => {
	switch (action.type) {
	case FETCH_COMPANIES_STATS_BEGIN:
		return {
			...state,
			loading: true,
		};

	case FETCH_COMPANIES_STATS_SUCCESS:
		return {
			...state,
			loading: false,
			stats: action.payload.stats,
			// pagination: {
			// 	numberOfElements : action.payload.numberOfElements,
			// 	totalElements: action.payload.totalElements,
			// 	totalPages: action.payload.totalPages
			// },
		};

	case FETCH_COMPANIES_STATS_ERROR:
		return {
			...state,
			loading: false,
			stats: []
		};

	case FETCH_FILTERED_COMPANIES_STATS: {
		return {
			...state,
			filteredStats: action.payload.filteredStats
		}
	}

	default:
		return state;
	}
};

export const companyStatsReducer  = (state = defaultCompanyStatsState, action) => {
	switch (action.type) {
	case FETCH_COMPANY_STATS_BEGIN:
		return {
			...state,
			loading: true,
		};

	case FETCH_COMPANY_STATS_SUCCESS:
		return {
			...state,
			loading: false,
			companyStats: action.payload.companyStats,
            storesStats:  action.payload.storesStats
			// pagination: {
			// 	numberOfElements : action.payload.numberOfElements,
			// 	totalElements: action.payload.totalElements,
			// 	totalPages: action.payload.totalPages
			// },
		};

	case FETCH_COMPANY_STATS_ERROR:
		return {
			...state,
			loading: false,
			companyStats: []
		};

	case FETCH_FILTERED_COMPANY_STATS: {
		return {
			...state,
			filteredCompanyStats: action.payload.filteredCompanyStats
		}
	}

	default:
		return state;
	}
};


export const storeStatsReducer  = (state = defaultStoreStatsState, action) => {
	switch (action.type) {
	case FETCH_STORE_STATS_BEGIN:
		return {
			...state,
			loading: true,
		};

	case FETCH_STORE_STATS_SUCCESS:
		return {
			...state,
			loading: false,
			storeStats: action.payload.storeStats,
            uploadReports:  action.payload.uploadReports
			// pagination: {
			// 	numberOfElements : action.payload.numberOfElements,
			// 	totalElements: action.payload.totalElements,
			// 	totalPages: action.payload.totalPages
			// },
		};

	case FETCH_STORE_STATS_ERROR:
		return {
			...state,
			loading: false,
			storeStats: []
		};

	case FETCH_FILTERED_STORE_STATS: {
		return {
			...state,
			filteredStoreStats: action.payload.filteredStoreStats
		}
	}

	default:
		return state;
	}
};

export const appsStatsReducer  = (state = defaultAppsStatsState, action) => {
	switch (action.type) {
		case FETCH_APPS_STATS_BEGIN:
			return {
				...state,
				loading: true,
			};

		case FETCH_APPS_STATS_SUCCESS:
			return {
				...state,
				loading: false,
				appsStats: action.payload.appsStats,
				pagination: {
					numberOfElements : action.payload.numberOfElements,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages
				},
			};

		case FETCH_APPS_STATS_ERROR:
			return {
				...state,
				loading: false,
				appsStats: []
			};

		default:
			return state;
	}
};

export const totalStatsReducer  = (state = defaultTotalStatsState, action) => {
	switch (action.type) {
		case FETCH_TOTAL_STATS_BEGIN:
			return {
				...state,
				loading: true,
			};

		case FETCH_TOTAL_STATS_SUCCESS:
			return {
				...state,
				loading: false,
				totalStats: action.payload.totalStats,
				pagination: {
					numberOfElements : action.payload.numberOfElements,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages
				},
			};

		case FETCH_TOTAL_STATS_ERROR:
			return {
				...state,
				loading: false,
				totalStats: []
			};

		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/stats.js